// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AutocompleteInput_container__k\\+J-O {
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
  margin-top: 3px;
  --padding: 5px 10px;
  --border-radius: 5px;
  transition: all 0.3s ease;
}
.AutocompleteInput_container__k\\+J-O * {
  transition: all 0.3s ease;
}
.AutocompleteInput_container__k\\+J-O .AutocompleteInput_input__2Bou- {
  width: 180px;
  background-color: rgb(246, 246, 246);
  border: 1px solid rgb(210, 210, 210);
  padding: var(--padding);
  border-radius: var(--border-radius);
  outline: none;
  max-width: 100%;
}
.AutocompleteInput_container__k\\+J-O .AutocompleteInput_suggestions__ZEJuL {
  position: absolute;
  width: calc(100% - 2px);
  margin: 0 1px;
  background-color: rgb(250, 250, 250);
  z-index: 10;
  border-bottom-left-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
  text-align: left;
  display: none;
  box-shadow: 0 2px 5px rgba(50, 50, 50, 0.3);
  overflow: hidden;
}
.AutocompleteInput_container__k\\+J-O .AutocompleteInput_suggestions__ZEJuL div {
  padding: var(--padding);
  cursor: pointer;
}
.AutocompleteInput_container__k\\+J-O .AutocompleteInput_suggestions__ZEJuL div:hover, .AutocompleteInput_container__k\\+J-O .AutocompleteInput_suggestions__ZEJuL div.AutocompleteInput_highlighted__qP7Ts {
  background-color: rgb(238, 238, 238);
}
.AutocompleteInput_container__k\\+J-O .AutocompleteInput_suggestions__ZEJuL div:active {
  background-color: rgb(230, 230, 230);
}
.AutocompleteInput_container__k\\+J-O.AutocompleteInput_showing-suggestions__UV5Kh .AutocompleteInput_input__2Bou-,
.AutocompleteInput_container__k\\+J-O .AutocompleteInput_input__2Bou-:focus {
  box-shadow: 0 0 5px rgba(50, 50, 50, 0.15);
}
.AutocompleteInput_container__k\\+J-O.AutocompleteInput_showing-suggestions__UV5Kh .AutocompleteInput_input__2Bou- {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-color: rgb(210, 210, 210);
}
.AutocompleteInput_container__k\\+J-O.AutocompleteInput_showing-suggestions__UV5Kh .AutocompleteInput_suggestions__ZEJuL {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/Components/AutocompleteInput/AutocompleteInput.module.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;AACJ;AACI;EACI,yBAAA;AACR;AAEI;EACI,YAAA;EACA,oCAAA;EACA,oCAAA;EACA,uBAAA;EACA,mCAAA;EACA,aAAA;EACA,eAAA;AAAR;AAGI;EACI,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;EACA,+CAAA;EACA,gDAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,gBAAA;AADR;AAGQ;EACI,uBAAA;EACA,eAAA;AADZ;AAGY;EAEI,oCAAA;AAFhB;AAKY;EACI,oCAAA;AAHhB;AAQI;;EAEI,0CAAA;AANR;AAWQ;EACI,4BAAA;EACA,6BAAA;EACA,gCAAA;AATZ;AAYQ;EACI,cAAA;AAVZ","sourcesContent":[".container {\n    width: fit-content;\n    position: relative;\n    margin-top: 3px;\n    --padding: 5px 10px;\n    --border-radius: 5px;\n    transition: all 0.3s ease;\n\n    * {\n        transition: all 0.3s ease;\n    }\n\n    .input {\n        width: 180px;\n        background-color: rgb(246, 246, 246);\n        border: 1px solid rgb(210, 210, 210);\n        padding: var(--padding);\n        border-radius: var(--border-radius);\n        outline: none;\n        max-width: 100%;\n    }\n\n    .suggestions {\n        position: absolute;\n        width: calc(100% - 2px);\n        margin: 0 1px;\n        background-color: rgb(250, 250, 250);\n        z-index: 10;\n        border-bottom-left-radius: var(--border-radius);\n        border-bottom-right-radius: var(--border-radius);\n        text-align: left;\n        display: none;\n        box-shadow: 0 2px 5px rgba(50, 50, 50, 0.3);\n        overflow: hidden;\n\n        div {\n            padding: var(--padding);\n            cursor: pointer;\n\n            &:hover,\n            &.highlighted {\n                background-color: rgb(238, 238, 238);\n            }\n\n            &:active {\n                background-color: rgb(230, 230, 230);\n            }\n        }\n    }\n\n    &.showing-suggestions .input,\n    .input:focus {\n        box-shadow: 0 0 5px rgba(50, 50, 50, 0.15);\n\n    }\n\n    &.showing-suggestions {\n        .input {\n            border-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n            border-color: rgb(210, 210, 210);\n        }\n\n        .suggestions {\n            display: block;\n\n            div {}\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AutocompleteInput_container__k+J-O`,
	"input": `AutocompleteInput_input__2Bou-`,
	"suggestions": `AutocompleteInput_suggestions__ZEJuL`,
	"highlighted": `AutocompleteInput_highlighted__qP7Ts`,
	"showing-suggestions": `AutocompleteInput_showing-suggestions__UV5Kh`
};
export default ___CSS_LOADER_EXPORT___;
